<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $tc("fandbAnalytics") }}</div>
      <div class="section-title mb-4"></div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <!-- START DATE -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getFNBChartFromDate"
                  v-on:click="
                    onChartDateHandler({ event: null, name: 'fromDate' })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onChartDateHandler({ event: $event, name: 'fromDate' })
                  "
                  ref="programaticOpen"
                  :value="getFNBChartFromDate || defultcurrdate"
                  typeable
                ></Datepicker>
                <label
                  :class="getFNBChartFromDate || defultcurrdate ? 'active' : ''"
                  >{{ $t("fromdate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getFNBChartEndDate"
                  v-on:click="
                    onChartDateHandler({ event: null, name: 'endDate' })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onChartDateHandler({ event: $event, name: 'endDate' })
                  "
                  ref="programaticOpen"
                  :value="getFNBChartEndDate || defultcurrdate"
                  typeable
                ></Datepicker>
                <label
                  :class="getFNBChartEndDate || defultcurrdate ? 'active' : ''"
                  >{{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button
              class="btn-blue-lg w-100"
              @click.prevent.stop="fetchFnbAnalyticsChart"
            >
              {{ $t("fetch") }}
            </button>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div
              class="btn-group pull-right"
              role="group"
              aria-label="Basic example"
            >
              <button
                type="button"
                @click="OnSelectFNBFilter('Day')"
                class="btn btn-secondary"
              >
                {{ $tc("day") }}
              </button>
              <button
                type="button"
                @click="OnSelectFNBFilter('Week')"
                class="btn btn-secondary"
              >
                {{ $tc("week") }}
              </button>
              <button
                type="button"
                @click="OnSelectFNBFilter('Month')"
                class="btn btn-secondary"
              >
                {{ $tc("month") }}
              </button>
            </div>
          </div>
        </div>

        <div v-if="FnBchartloaded">
          <h5>Daily Foods and Beverages Categories Sale</h5>
          <line-chart
            :chartdata="CategoryChartData"
            :options="getChartOptions"
          />
          <br />
          <br />
          <pie-chart
            :chartdata="PiechartDataFnBCategories"
            :options="getChartOptions"
          />
          <br />
          <br />
          <h5>Daily Foods and Beverages Items Sale</h5>
          <line-chart :chartdata="chartData" :options="getChartOptions" />
          <br />
          <br />
          <pie-chart
            :chartdata="PiechartDataFnBItems"
            :options="getChartOptions"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import LineChart from "@/components/ChartComponents/LineChart.js";
import PieChart from "@/components/ChartComponents/PieChart.js";

export default {
  components: { LineChart, PieChart },
  data() {
    return {};
  },
  computed: {
    chartData() {
      return {
        labels: this.getFnbLables,
        datasets: this.getFnbdatasets,
      };
    },
    PiechartDataFnBItems() {
      return {
        labels: this.getFnBpielabels,
        datasets: this.getFnBpiedatasets,
      };
    },
    CategoryChartData() {
      return {
        labels: this.getFnbLables,
        datasets: this.getFnBCategoriesdatasets,
      };
    },
    PiechartDataFnBCategories() {
      return {
        labels: this.getFnBCategoriesPieLabel,
        datasets: this.getFnBCategoriesPieDatasets,
      };
    },
    ...mapGetters([
      "getChartOptions",
      "getFnbLables",
      "getFnbdatasets",
      "getFnBpielabels",
      "getFnBpiedatasets",
      "getFnBCategoriesdatasets",
      "getFnBCategoriesPieLabel",
      "getFnBCategoriesPieDatasets",
      "FnBchartloaded",
      "getScreenCollectionReportsIsCinema",
      // End
      "getFNBChartFromDate",
      "getFNBChartEndDate",
    ]),
    defultcurrdate() {
      return new Date();
    },
  },
  beforeMount() {
    // console.log("screenCollectionReportsList :", screenCollectionReportsList);
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;

    this.FnBClearDates(null);
    this.FnBHideChart({ chartShow: false, chartClear: [] });
  },
  mounted() {},
  methods: {
    ...mapActions([
      "onChartDateHandler",
      "fetchFnbAnalyticsChart",
      "OnSelectFNBFilter",
      "FnBClearDates",
      "FnBHideChart",
    ]),
  },
  beforeDestroy: async function () {},
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnBComponents/fnbAnalytics.vue